import { KYMW1100Model } from '../kymw1100.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessResult } from 'src/app/shared/vo/pless-result.model';

/**
 * 仕入価格計算クラス
 *
 * @export GetPurchasePriceService
 * @class GetPurchasePriceService
 * @extends {PlessResponder}
 */
@Injectable()
export class GetPurchasePriceService extends PlessJsonResponderSub<any> {
  // 処理に使用するModel
  private model: KYMW1100Model;
  private vo: any;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessResult} リクエストJSON
   * @memberof GetPurchasePriceService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        BundlePrice: this.vo[0],
        CoopCode: this.vo[1],
        CostPriceStandard: this.vo[2],
        CostPriceSpecial1: this.vo[3],
        CostPriceSpecial2: this.vo[4]
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetPurchasePriceService
   */
  execute(model: KYMW1100Model, vo: any, successFunc: Function = null): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('getPurchasePrice', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetPurchasePriceService
   */
  success(data: any): void {
    if (this.successFunc !== null) {
      this.successFunc(data);
    }
  }
}
